import CollapsibleCard from "../../../components/collapsible-card/collapsible-card";
import { useEffect, useState } from "react";
import AuthorFqasService from "../../../services/http/author-fqas.service";
import { AuthorFqa } from "@app/types/author-fqa.type";

function FAQManagement() {
  const [faqs, setFaqs] = useState<AuthorFqa[]>([]);

  useEffect(() => {
    AuthorFqasService.getList().then((res) => {
      setFaqs(res.data.items);
    });
  }, []);

  return (
    <div className="py-6 px-12">
      <div className="mt-6 flex flex-col gap-[24px]">
        {faqs.map((faq) => (
          <CollapsibleCard key={faq.id} title={faq.question}>
            <ol className="list-decimal list-inside space-y-2">
              {faq.answers.map((answer, id) => (
                <li
                  key={id}
                  className="text-[#506079] text-[14px]"
                  dangerouslySetInnerHTML={{ __html: answer }}
                />
              ))}
            </ol>
          </CollapsibleCard>
        ))}
      </div>
    </div>
  );
}

export default FAQManagement;
